module.exports = __webpack_public_path__ + "img/DAY3-1.32c12fd9.jpg";